import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import {
  TabContainer,
  ThankyouHeader,
  ThankyouMessage,
} from "../SocialCaseTbas/Social.styled";
// import { InputContainer } from ".../../MoveOut.styled";
import cc from "../../assets/ccIcon.svg";
import { Label } from "../../screens/complaint/Complaint.styled";
import cvv from "../../assets/cvv.svg";
import CloseIcon from "../../assets/CloseIcon.svg";
import ThanksIcon from "../../assets/thanks.svg";
import styled from "styled-components";

import OtpInput from "react18-input-otp";

import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import { NotifyError } from "../../utils/ShowError";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import {
  generateUUID,
  maskEmail,
  maskUaeMobile,
} from "../../../src/utils/utilityHelper";
import { OtpProtectedOperations } from "../../../src/utils/constants";

const InputContainer = styled.div<{ BackGround?: string }>`
  width: 40%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  input {
    height: 2.5rem;
    width: 2.5rem !important;
    background: ${(props) => (props.BackGround ? props.BackGround : "#edf4f6")};
    border: 1px solid
      ${(props) => (props.BackGround ? props.BackGround : "#b6bfdc")};
    margin: 0 0.5rem;
  }
`;

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  setEnableMobilebleField: any;
  //   onVerify:any,
  onClose?: React.MouseEventHandler<HTMLImageElement | HTMLButtonElement>;

  email: string;
  mobile: string;
  setEmail?: any;
  setMobile?: any;
  personID: string;
  BackGround?: string;
  isMobileEdit: Boolean;
}

const ProfileOTP = ({
  mobile,
  email,
  personID,
  onClose,
  setEmail,
  setMobile,
  isMobileEdit,
}: Props) => {
  const transactionIdRef = useRef<string>(generateUUID());
  const [screen, setScreen] = useState<number>(0);
  const [numbers, setNumbers] = useState("");
  const [emailMobilevalidation, setEmailMobilevalidation] = useState<any>(true);
  const [err, setErr] = useState<any>(false);

  const [otpDestination, setOtpDestination] = useState<number>(0);
  const newDestinationValueRef = useRef<HTMLInputElement | null>(null);
  const [newMobile, setNewMobile] = useState<any>();
  const [newEmail, setNewEmail] = useState<any>();

  const handleChange = (otpConfirm: any) => {
    const regex = /^[0-9]+$/;

    if (otpConfirm.length < numbers.length) {
      // Backspace pressed
      setNumbers(otpConfirm);
    } else if (regex.test(otpConfirm)) {
      // Normal input
      setNumbers(otpConfirm);
    }
  };
  const getUser = async () => {
    const res: any = await User.getProfile(User.info.personId as string);
    if (res) {
      setEmail(res?.result?.email);
      setMobile(res?.result?.mobileNumber);
    }
  };

  useEffect(() => {
    if (User.profile.mobileNumber == null && User?.profile?.email == null) {
      NotifyError(General?.codeLabels["cm_mob_usecsslogin"]?.label);
    }
  }, []);

  const [verifyloader, setverifyLoader] = useState(false);
  const handleVerification = async () => {
    setverifyLoader(true);
    const newVal = newDestinationValueRef.current?.value;
    const isEditFlow = Boolean(newMobile || newEmail);

    const res = await General.verifyOTP({
      errorId: "verifyOTPError",
      data: {
        numbers: numbers,
        transactionId: transactionIdRef.current,
        operation: isEditFlow
            ? OtpProtectedOperations.EditProfile
            : OtpProtectedOperations.ValidateProfile,
      },
    });

    !newMobile && setNumbers("");
    if (res?.result?.message == "Success") {
      if (newMobile||newEmail) {
        const data = {
          emailId: !isMobileEdit ? newEmail : email,
          mobileNumber: isMobileEdit ? newMobile : mobile,
          oldMobileNumber: mobile === "NA" ? null : mobile,
          mode: isMobileEdit ? "mobile" : otpDestination === 2 ? "email" : null,
          transactionId: transactionIdRef.current,
        };

        const res = await User.updateContactDetails({
          errorId: "updateContactDetailsError",
          data,
        });
        if (res?.message == "Success") {
          setverifyLoader(false);
          setNumbers("");
          setScreen(3);
          getUser();
        }
      } else {
        setScreen(2);
        setverifyLoader(false);
      }
    }

    // if(onVerify)
    //   onVerify()
  };
  const [mobileRadioChecked, setMobileRadioChecked] = useState(false);
  const handleMobileRadioButton = async (event: any) => {
    const mobileNumber = User.profile?.mobileNumber;
    if (mobileNumber && mobileNumber.toUpperCase() !== "NA") {
      setMobileRadioChecked(true);
      setOtpDestination(1);
    } else {
      NotifyError(
        General?.codeLabels["cm_mobilenumberreqerr"]?.label +
          " " +
          General?.codeLabels["cm_interr"]?.label
      );
    }
  };
  const [emailRadioChecked, setEmailRadioChecked] = useState(false);
  const [getCodeFlag, setGetCodeFlag] = useState(false);
  const handleEmailRadioButton = async (event: any) => {
    const emailId = User.profile?.email;
    if (emailId && emailId.toUpperCase() !== "NA") {
      setEmailRadioChecked(true);
      setOtpDestination(2);
    } else {
      NotifyError(
        General?.codeLabels["cm_email_rqd"]?.label +
          " " +
          General?.codeLabels["cm_interr"]?.label
      );
    }
  };
  const [sendotploader, setsendotploader] = useState(false);
  const handleSendOTP = async () => {
    setNumbers("");
    setsendotploader(true);
    const newVal =
  newDestinationValueRef.current?.value ||
  (otpDestination === 2 ? newEmail : newMobile);
    if (otpDestination == 1) {
      await General.sendOTP({
        errorId: "sendOTPError",
        data: {
          premiseId: null,
          email: null,
          mobile: newVal ? newVal : newMobile ? newMobile : mobile,
          personID,
          transactionId: transactionIdRef.current,
          operation: newMobile
            ? OtpProtectedOperations.EditProfile
            : OtpProtectedOperations.ValidateProfile,
          isEditFlow: screen === 2,
        },
      });
      setScreen(1);
      setsendotploader(false);
    } else if (otpDestination === 2) {
      await General.sendOTP({
        errorId: "sendOTPError",
        data: {
          premiseId: null,
          email: newVal ? newVal : email,
          mobile: null,
          personID,
          transactionId: transactionIdRef.current,
          operation: newVal
            ? OtpProtectedOperations.EditProfile
            : OtpProtectedOperations.ValidateProfile,
          // useProvidedContactInfo: getCodeFlag ? true : false,
          isEditFlow: screen === 2,
        },
      });
      setScreen(1);
      setsendotploader(false);
    } else {
      NotifyError("Error: Please Select OTP Destination");
      setsendotploader(false);
    }
  };

  //   useEffect(()=>{
  //     General.sendOTP({errorId: 'sendOTPError', data: {premiseId:null, email, mobile, personID}})
  //   },[])
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  useEffect(() => {
    if (getCodeFlag) {
      handleSendOTP();
    }
  }, [getCodeFlag]);

  return (
    <div
      style={{
        minWidth: "45%",
        overflow: "auto",
        margin: "auto",
        direction:
          General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA"
            ? "rtl"
            : "ltr",
      }}
    >
      <div
        style={{
          // height: '20%',
          width: "100%",
          justifyContent: "space-between",
          padding: "1rem",
          background: contrast?.contrastColor
            ? contrast?.contrastColor
            : ColorAss,
          display: "flex",
          alignItems: "center",
        }}
      >
        <h1
          style={{
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
            justifySelf: "flex-start",
            fontSize: `${2 * General.accessibility.fontSize}rem`,
          }}
        >
          {isMobileEdit
            ? General?.codeLabels["cm_edit_mobile"]?.label !== undefined
              ? General?.codeLabels["cm_edit_mobile"]?.label
              : "Edit Mobile Number"
            : General?.codeLabels["cm_edit_email"]?.label !== undefined
            ? General?.codeLabels["cm_edit_email"]?.label
            : "Edit Email"}
        </h1>

        <img src={CloseIcon} alt="" onClick={onClose} />
      </div>

      <TabContainer
        style={{
          padding: "0px 0px 12px 0px",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "white",
          color: contrast?.contrastColor
            ? contrast?.contrastColor
            : General?.ColorAss,
        }}
      >
        {screen === 0 ? (
          <>
            <Typography
              component="p"
              sx={{
                paddingTop: "12px",
                fontWeight: "700",
                fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_where_otp"]?.label !== undefined
                ? General?.codeLabels["cm_where_otp"]?.label
                : "Where can we send the OTP"}
            </Typography>

            <p
              style={{
                width: "70%",
                textAlign: "center",
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_otp_verify"]?.label !== undefined
                ? General?.codeLabels["cm_otp_verify"]?.label
                : "We need to verify your existing details before we let you edit"}
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "baseline", gap: "5px" }}
              >
                <input
                  type={"radio"}
                  name={"otpDest"}
                  checked={mobileRadioChecked}
                  onClick={handleMobileRadioButton}
                />
                <p
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_otp_mode_mobile"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_otp_mode_mobile"]?.label
                    : "registered mobile"}
                  <br /> {maskUaeMobile(mobile)}
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  gap: "5px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                }}
              >
                <input
                  type={"radio"}
                  name={"otpDest"}
                  checked={emailRadioChecked}
                  onClick={handleEmailRadioButton}
                />
                <p
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_otp_mode_email"]?.label !== undefined
                    ? General?.codeLabels["cm_otp_mode_email"]?.label
                    : "registered email"}{" "}
                  <br /> {maskEmail(email)}
                </p>
              </div>
            </div>

            <ButtonsContainer
              style={{ display: "flex", gap: "12px", width: "fit-content" }}
            >
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  background: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  borderColor: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                }}
                onClick={onClose}
              >
                {General?.codeLabels["cm_cancel"]?.label !== undefined
                  ? General?.codeLabels["cm_cancel"]?.label
                  : "CANCEL"}
              </ButtonSecondary>
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "white",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  whiteSpace: "nowrap",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  border: "none",
                }}
                onClick={handleSendOTP}
              >
                {sendotploader ? (
                  <Spinner width="30px" height="30px" />
                ) : General?.codeLabels["cm_send_otp"]?.label !== undefined ? (
                  General?.codeLabels["cm_send_otp"]?.label
                ) : (
                  "SEND OTP"
                )}
              </ButtonSecondary>
            </ButtonsContainer>
          </>
        ) : null}

        {screen === 1 ? (
          <>
            <Typography
              component="p"
              sx={{
                paddingTop: "12px",
                fontWeight: "700",
                fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_otp_send"]?.label !== undefined
                ? General?.codeLabels["cm_otp_send"]?.label
                : "Please enter the one-time password"}
            </Typography>
            <p
              style={{
                width: "60%",
                textAlign: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_we_send"]?.label !== undefined ? General?.codeLabels["cm_we_send"]?.label : "We have sent the OTP On this"}{" "}
              {newMobile
                ? newMobile
                : otpDestination == 1
                ? `${General?.codeLabels["cm_mobile_number"]?.label !== undefined ? General?.codeLabels["cm_mobile_number"]?.label : "mobile number"} ${newMobile ? maskUaeMobile(newMobile) : maskUaeMobile(mobile)}`
                : `${General?.codeLabels["cm_email_id"]?.label !== undefined ? General?.codeLabels["cm_email_id"]?.label : "email"} ${newMobile ? newMobile : newEmail ? newEmail : email}`}
            </p>

            <InputContainer
              BackGround={
                contrast?.contrastColor ? contrast?.contrastColor : ""
              }
              style={{ justifyContent: "center", direction: "ltr" }}
            >
              <OtpInput
                value={numbers}
                onChange={handleChange}
                numInputs={6}
                isInputNum={true}
              />
            </InputContainer>

            <p
              style={{
                width: "70%",
                textAlign: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                marginTop: "0.5rem",
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {otpDestination === 2
                ? General?.codeLabels["cm_em_otp2min"]?.label !== undefined
                  ? General?.codeLabels["cm_em_otp2min"]?.label
                  : "If you do not receive email OTP within 5 minutes"
                : General?.codeLabels["cm_mob_otp2min"]?.label !== undefined
                ? General?.codeLabels["cm_mob_otp2min"]?.label
                : "If you do not receive mobile OTP within 5 minutes"}{" "}
              &nbsp;
              <span
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  fontWeight: "700",
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                }}
                onClick={handleSendOTP}
              >
                {General?.codeLabels["cm_mob_resendotp"]?.label !== undefined
                  ? General?.codeLabels["cm_mob_resendotp"]?.label
                  : "Resend OTP"}{" "}
              </span>
            </p>
            <ButtonsContainer
              style={{ display: "flex", gap: "12px", width: "fit-content" }}
            >
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  background: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  borderColor: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                }}
                onClick={() => setScreen(0)}
              >
                {General?.codeLabels["cm_backbutton"]?.label !== undefined
                  ? General?.codeLabels["cm_backbutton"]?.label
                  : "BACK"}
              </ButtonSecondary>
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "white",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  fontSize: `${General.accessibility.fontSize}rem`,
                  border: "none",
                }}
                onClick={handleVerification}
              >
                {verifyloader ? (
                  <Spinner width="30px" height="30px" />
                ) : General?.codeLabels["cm_verifybtn_verify"]?.label !==
                  undefined ? (
                  General?.codeLabels["cm_verifybtn_verify"]?.label
                ) : (
                  "VERIFY"
                )}
              </ButtonSecondary>
            </ButtonsContainer>
          </>
        ) : null}

        {screen === 2 ? (
          <>
            <Typography
              component="p"
              sx={{
                fontWeight: "700",
                fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {isMobileEdit
                ? General?.codeLabels["cm_mob_val"]?.label !== undefined
                  ? General?.codeLabels["cm_mob_val"]?.label
                  : "Please Enter Your New Mobile Number"
                : General?.codeLabels["cm_enter_email"]?.label !== undefined
                ? General?.codeLabels["cm_enter_email"]?.label
                : "Please Enter Your New Email Id"}
            </Typography>
            <p
              style={{
                width: "50%",
                textAlign: "center",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss,
              }}
            >
              {General?.codeLabels["cm_we_send_new"]?.label !== undefined ? General?.codeLabels["cm_we_send_new"]?.label : "We will send a verification code to your new"}{" "}{isMobileEdit ? (General?.codeLabels["cm_mobile_number"]?.label !== undefined ? General?.codeLabels["cm_mobile_number"]?.label : "mobile number") : (General?.codeLabels["cm_email_id"]?.label !== undefined ? General?.codeLabels["cm_email_id"]?.label : "email Id")}
            </p>

            <input
              style={{
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "#E5EFF2",
                height: "3rem",
                width: "20rem",
                marginBottom: err ? "" : "1rem",
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : General?.ColorAss,
              }}
              value={isMobileEdit ? newMobile : newEmail}
              type={isMobileEdit ? "tel" : "email"}
              onChange={(e) => {
                if (isMobileEdit) {
                  setNewMobile(e.target.value);
                } else {
                  setNewEmail(e.target.value);
                }
                if (isMobileEdit) {
                  setOtpDestination(1);
                } else {
                  setOtpDestination(2);
                }
              }}
              onBlur={(e: any) => {
                var regex = isMobileEdit
                  ? /^05[0-9]{8}$/
                  : /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
                if (regex?.test(e.target?.value)) {
                  setEmailMobilevalidation(false);
                  setErr(false);
                } else {
                  setEmailMobilevalidation(true);
                  setErr(true);
                }
              }}
              ref={newDestinationValueRef}
            />
            {err && (
              <div
                style={{
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "red",
                  marginBottom: "1rem",
                }}
              >
                {isMobileEdit
                  ? General?.codeLabels["cm_ivalid_mobile"]?.label
                  : General?.codeLabels["cm_emailerr"]?.label}
              </div>
            )}

            <ButtonsContainer
              style={{ display: "flex", gap: "12px", width: "fit-content" }}
            >
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  background: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  borderColor: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                }}
                onClick={() => {
                  setNewMobile(null);
                  setScreen(1);
                }}
              >
                {General?.codeLabels["cm_back"]?.label !== undefined
                  ? General?.codeLabels["cm_back"]?.label
                  : "BACK"}
              </ButtonSecondary>

              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "auto",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "white",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  border: "none",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  whiteSpace: "nowrap",
                  opacity: emailMobilevalidation ? "0.5" : "1",
                }}
                onClick={() => {
                  if (!emailMobilevalidation) {
                    setGetCodeFlag(true); // This will trigger the useEffect above
                  }
                }}
                disabled={emailMobilevalidation}
              >
                {sendotploader ? (
                  <Spinner width="30px" height="30px" />
                ) : General?.codeLabels["cm_otp_getcode"]?.label !==
                  undefined ? (
                  General?.codeLabels["cm_otp_getcode"]?.label
                ) : (
                  "Get Code"
                )}
              </ButtonSecondary>
            </ButtonsContainer>
          </>
        ) : null}

        {screen === 3 ? (
          <>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                alignSelf: "flex-start",
              }}
            >
              <ThankyouHeader
                style={{
                  background: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#e0eedc",
                  padding: "12px 0px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="46"
                  height="46"
                  viewBox="0 0 46 46"
                  fill="none"
                >
                  <path
                    d="M23 0C10.317 0 0 10.317 0 23C0 35.683 10.317 46 23 46C35.683 46 46 35.683 46 23C46 18.44 44.6603 14.1893 42.3633 10.6113L40.9941 12.2285C42.8891 15.3825 44 19.06 44 23C44 34.579 34.579 44 23 44C11.421 44 2 34.579 2 23C2 11.421 11.421 2 23 2C28.443 2 33.3939 4.09977 37.1289 7.50977L38.4375 5.96484C34.3525 2.25984 28.935 0 23 0ZM41.2363 5.75391L21.9141 28.5547L13.7812 20.9688L12.418 22.4316L22.084 31.4473L42.7637 7.04688L41.2363 5.75391Z"
                    fill={
                      contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#62AA51"
                    }
                  />
                </svg>

                <h1
                  style={{
                    margin: "0",
                    marginBottom: "13px",
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: `${2.125 * General.accessibility.fontSize}rem`,
                    lineHeight: "130%",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_thankyou"]?.label !== undefined
                    ? General?.codeLabels["cm_thankyou"]?.label
                    : "Thank You"}
                </h1>
              </ThankyouHeader>
              <ThankyouMessage>
                <p
                  style={{
                    padding: "0",
                    margin: "0",
                    marginTop: "20px",
                    marginBottom: "20px",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    fontWeight: "700",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_otp_success"]?.label !== undefined
                    ? General?.codeLabels["cm_otp_success"]?.label
                    : "You have successfully changed your"}{" "}
                  {isMobileEdit
                    ? General?.codeLabels["cm_mob_mobnum"]?.label !== undefined
                      ? General?.codeLabels["cm_mob_mobnum"]?.label
                      : "mobile number"
                    : General?.codeLabels["cm_mob_emailid"]?.label !== undefined
                    ? General?.codeLabels["cm_mob_emailid"]?.label
                    : "email Id"}
                </p>

                <ButtonSecondary
                  onClick={onClose}
                  style={{
                    height: "50px",
                    width: "252px",
                    fontFamily: "Segoe UI",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "130%",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#fff",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    border: "none",
                  }}
                >
                  {General?.codeLabels["cm_close"]?.label !== undefined
                    ? General?.codeLabels["cm_close"]?.label
                    : "Close"}
                </ButtonSecondary>
              </ThankyouMessage>
            </div>
          </>
        ) : null}
      </TabContainer>
    </div>
  );
};

export default observer(ProfileOTP);
